import { render, staticRenderFns } from "./VsTableModified.vue?vue&type=template&id=0c44a6b3&scoped=true&"
import script from "./VsTableModified.vue?vue&type=script&lang=js&"
export * from "./VsTableModified.vue?vue&type=script&lang=js&"
import style0 from "./VsTableModified.vue?vue&type=style&index=0&id=0c44a6b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c44a6b3",
  null
  
)

export default component.exports